/* eslint-disable */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getStats } from "../../actions";
import "./styles.scss";
import moment from "moment";
import Statistics from "../../components/Statistics";
import AppGrids from "../../components/AppGrids";
import { options } from "../../config/constants";

const cardTypes = [
  {
    header: "New insurance policies",
    firstLine: "purchased policies",
    secondLine: "Users with purchased policies",
    firstField: "purchasedPolicies",
    secondField: "purchasedPoliciesUsers",
    tab: "newPolicies",
  },
  {
    header: "Added insurance policies",
    firstLine: "Added insurance policies",
    secondLine: "users with added policies",
    firstField: "addedPolicies",
    secondField: "addedPoliciesUsers",
    tab: "orderedPolicies",
  },
  {
    header: "Insurance instalments",
    firstLine: "Paid Insurance instalments",
    secondLine: "users with paid instalments",
    firstField: "installmentsPaid",
    secondField: "installmentsPaidUsers",
    tab: "installments",
  },
  {
    header: "Police fines",
    firstLine: "paid tickets and fines",
    secondLine: "users with paid tickets and fines",
    firstField: "finesPaid",
    secondField: "finesPaidUsers",
    tab: "fines",
  },
  {
    header: "Vignettes",
    firstLine: "purchased Vignettes",
    secondLine: "Users with purchased Vignettes",
    firstField: "purchasedVignettes",
    secondField: "purchasedVignettesUsers",
    tab: "vignettes",
  },
  {
    header: "Parking zones",
    firstLine: "paid Parking zones",
    secondLine: "users with paid parking zone",
    firstField: "parkingReminders",
    secondField: "parkingRemindersUsers",
    tab: "parkingZones",
  },
  {
    header: "Claims",
    firstLine: "Filled Claims",
    secondLine: "Users with claims",
    firstField: "claims",
    secondField: "claimsUsers",
    tab: "claims",
  },
  {
    header: "Costs",
    firstLine: "manually added costs",
    secondLine: "Users with manually added costs",
    firstField: "manualExpenses",
    secondField: "manualExpensesUsers",
    tab: "costs",
  },
  {
    header: "Calendar",
    firstLine: "manually added events",
    secondLine: "Users with manually added events",
    firstField: "manualEvents",
    secondField: "manualEventsUsers",
    tab: "calendar",
  },
  // {
  //   header: "Dash Cam",
  //   firstLine: "dash cam sessions",
  //   secondLine: "created highlights",
  //   thirdLine: "sent reports",
  //   fourthLine: "users with dash cam sessions",
  //   fifthLine: "users with created highlights",
  //   sixthLine: "users with sent reports",
  //   firstField: "dashcamSessions",
  //   secondField: "dashcamVideos",
  //   thirdField: "dashcamReportedVideos",
  //   fourthField: "dashcamSessionsUsers",
  //   fifthField: "dashcamSessionUsersWithVideos",
  //   sixthField: "dashcamReportedVideosUsers",
  //   tab: "dash",
  // },
  {
    header: 'Average Speed',
    firstLine: "times opened the map with avg speed sections",
    secondLine: "users opened the map with avg speed sections",
    thirdLine: "sessions with active avg speed control",
    fourthLine: "users with active avg speed control",
    firstField: "fetched",
    secondField: "fetchedUsers",
    thirdField: "sessions",
    fourthField: "sessionsUsers",
    tab: "averageSpeed",
  },
  {
    header: "Dash Cam",
    firstLine: "number of dashcam purchases",
    secondLine: "users who made a dashcam purchase",
    thirdLine: "number of published videos",
    fourthLine: "users who published a dashcam video",
    fifthLine: "number of feed reactions",
    sixthLine: "users with dashcam feed reactions",
    firstField: "dashcamPurchases",
    secondField: "dashcamPurchasesUsers",
    thirdField: "dashcamPublishedReports",
    fourthField: "dashcamPublishedReportUsers",
    fifthField: "dashcamFeedReactions",
    sixthField: "dashcamFeedReactionsUsers",
    tab: "dashCam",
    tableOnClick: { first: "purchases", second: "purchases", third: "publishedReports", fourth: "publishedReports" },
  },
];

const App = ({ stats, getStats }) => {
  const defaultSelPeriod = Object.fromEntries(
    cardTypes.map(({ tab }) => [
      tab,
      {
        createdAtFrom: options[1].value,
        createdAtTo: moment().endOf("day").toISOString(),
      },
    ])
  );

  const [selTab, setSelTab] = useState("newPolicies");
  const [selPeriod, setSelPeriod] = useState(defaultSelPeriod);
  const [filtered, setFiltered] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filteredTab, setFilteredTab] = useState(null);
  const [dashCamTable, setDashCamTable] = useState("purchases");

  useEffect(() => {
    getStats({
      startDate: moment().subtract(7, "days").startOf("day").toISOString(),
      endDate: moment().endOf("day").toISOString(),
    });
  }, []);

  useEffect(() => {
    if (filtered) {
      getStats({
        startDate: selPeriod?.[filteredTab]?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
        endDate: selPeriod?.[filteredTab]?.createdAtTo || moment().endOf("day").toISOString(),
        tab: filteredTab,
      });
    }
  }, [selPeriod, filtered, filteredTab]);

  return (
    <div className="main-container">
      <div
        style={{
          height: "25%",
          width: "100%",
          padding: "10px",
          display: "flex",
          overflowX: "scroll",
          overflowY: "hidden",
        }}
      >
        {cardTypes.map((card, i) => {
          return (
            <React.Fragment key={i}>
              <div className={`card-grid ${card.tab === "dash" && "bigger"} ${card.tab === "averageSpeed" && "semi-bigger"} ${card.tab === "dashCam" && "dashCam-bigger"}`}>
                <div
                  className={`card-header ${card.tab === selTab && "selected"}`}
                  onClick={() => {
                    if (selTab !== card.tab) {
                      setLoading(true);
                      setSelTab(card.tab);
                      if (card.tab === "dashCam") setDashCamTable("purchases");
                    }
                  }}
                >
                  <h2
                    className={`${card.tab === selTab ? "font-bold" : "font-semiBold"}`}
                    style={{
                      textTransform: "uppercase",
                      width: "93%",
                      marginLeft: "5px",
                      color: card.tab === selTab ? "white" : "black",
                    }}
                  >
                    {card.header}
                  </h2>

                  <Statistics.SelectPeriod selPeriod={selPeriod} setSelPeriod={setSelPeriod} setFilteredTab={setFilteredTab} tab={card.tab} setFiltered={setFiltered} startField={"createdAtFrom"} endField={"createdAtTo"} selected={card.tab === selTab} />
                </div>
                <div className={`card-body ${card.tab === "dash" && "bigger"} ${card.tab === "averageSpeed" && "semi-bigger"} ${card.tab === "dashCam" && "dashCam-bigger"}`}>
                  <div
                    className={`card-row ${card.tab === "dash" && "semi-width"} ${card.tab === "averageSpeed" && "averageSpeed-width"} ${card.tab === "dashCam" && "dashCam-width"} ${card.tableOnClick?.first ? "clickable" : ""}`}
                    style={card.tab === "dashCam" ? { order: 1 } : undefined}
                    onClick={() => {
                      if (card.tableOnClick?.first) {
                        if (selTab !== "dashCam") setLoading(true);
                        setSelTab("dashCam");
                        setDashCamTable(card.tableOnClick.first);
                      }
                    }}
                  >
                    <div className={`indicator ${card.tab === "dashCam" ? (dashCamTable === "purchases" ? "blue" : "gray") : "blue"}`} />
                    <p className="row-data">
                      <b>{stats?.[card?.firstField] || "---"} </b>
                      {card.firstLine}
                    </p>
                  </div>
                  <div
                    className={`card-row ${card.tab === "dash" && "semi-width"} ${card.tab === "averageSpeed" && "averageSpeed-width"} ${card.tab === "dashCam" && "dashCam-width"} ${card.tableOnClick?.second ? "clickable" : ""}`}
                    style={card.tab === "dashCam" ? { order: 4 } : undefined}
                    onClick={() => {
                      if (card.tableOnClick?.second) {
                        if (selTab !== "dashCam") setLoading(true);
                        setSelTab("dashCam");
                        setDashCamTable(card.tableOnClick.second);
                      }
                    }}
                  >
                    <div className={`indicator ${card.tab === "dashCam" ? (dashCamTable === "purchases" ? "blue" : "gray") : "blue"}`} />
                    <p className="row-data">
                      <b>{card.secondField.includes("/") ? stats?.[card?.secondField.split("/")[0]] + stats?.[card?.secondField.split("/")[1]] : stats?.[card?.secondField] || "---"} </b>
                      {(stats?.[card?.secondField] ?? "---") === 1 && card.secondLine?.includes("users") ? card.secondLine.replace("users", "user") : card.secondLine}
                    </p>
                  </div>
                  {card.tab === "dash" && (
                    <>
                      <div className={`card-row ${card.tab === "dash" && "semi-width"}`}>
                        <div className="indicator gray" />
                        <p className="row-data">
                          <b>{stats?.[card?.thirdField] || "---"} </b>
                          {card.thirdLine}
                        </p>
                      </div>
                      <div className={`card-row ${card.tab === "dash" && "semi-width"}`}>
                        <div className="indicator gray" />
                        <p className="row-data">
                          <b>{stats?.[card?.fourthField] || "---"} </b>
                          {card.fourthLine}
                        </p>
                      </div>
                      <div className={`card-row ${card.tab === "dash" && "semi-width"}`}>
                        <div className="indicator gray" />
                        <p className="row-data">
                          <b>{stats?.[card?.fifthField] || "---"} </b>
                          {card.fifthLine}
                        </p>
                      </div>
                      <div className={`card-row ${card.tab === "dash" && "semi-width"}`}>
                        <div className="indicator gray" />
                        <p className="row-data">
                          <b>{stats?.[card?.sixthField] || "---"} </b>
                          {card.sixthLine}
                        </p>
                      </div>
                    </>
                  )}
                  {card.tab === "averageSpeed" && (
                    <>
                      <div className={`card-row ${card.tab === "averageSpeed" && "averageSpeed-width"}`}>
                        <div className="indicator gray" />
                        <p className="row-data">
                          <b>{stats?.[card?.thirdField] || "---"} </b>
                          {card.thirdLine}
                        </p>
                      </div>
                      <div className={`card-row ${card.tab === "averageSpeed" && "averageSpeed-width"}`}>
                        <div className="indicator gray" />
                        <p className="row-data">
                          <b>{stats?.[card?.fourthField] || "---"} </b>
                          {card.fourthLine}
                        </p>
                      </div>
                    </>
                  )}
                  {card.tab === "dashCam" && (
                    <>
                      <div
                        className={`card-row dashCam-width ${card.tableOnClick?.third ? "clickable" : ""}`}
                        style={{ order: 2 }}
                        onClick={() => {
                          if (card.tableOnClick?.third) {
                            if (selTab !== "dashCam") setLoading(true);
                            setSelTab("dashCam");
                            setDashCamTable(card.tableOnClick.third);
                          }
                        }}
                      >
                        <div className={`indicator ${dashCamTable === "publishedReports" ? "blue" : "gray"}`} />
                        <p className="row-data">
                          <b>{stats?.[card?.thirdField] || "---"} </b>
                          {(stats?.[card?.thirdField] ?? "---") === 1 && card.thirdLine?.includes("users") ? card.thirdLine.replace("users", "user") : card.thirdLine}
                        </p>
                      </div>
                      <div
                        className={`card-row dashCam-width ${card.tableOnClick?.fourth ? "clickable" : ""}`}
                        style={{ order: 5 }}
                        onClick={() => {
                          if (card.tableOnClick?.fourth) {
                            if (selTab !== "dashCam") setLoading(true);
                            setSelTab("dashCam");
                            setDashCamTable(card.tableOnClick.fourth);
                          }
                        }}
                      >
                        <div className={`indicator ${dashCamTable === "publishedReports" ? "blue" : "gray"}`} />
                        <p className="row-data">
                          <b>{stats?.[card?.fourthField] || "---"} </b>
                          {(stats?.[card?.fourthField] ?? "---") === 1 && card.fourthLine?.includes("users") ? card.fourthLine.replace("users", "user") : card.fourthLine}
                        </p>
                      </div>
                      <div className="card-row dashCam-width" style={{ order: 3 }}>
                        <div className="indicator gray" />
                        <p className="row-data">
                          <b>{stats?.[card?.fifthField] || "---"} </b>
                          {(stats?.[card?.fifthField] ?? "---") === 1 && card.fifthLine?.includes("users") ? card.fifthLine.replace("users", "user") : card.fifthLine}
                        </p>
                      </div>
                      <div className="card-row dashCam-width" style={{ order: 6 }}>
                        <div className="indicator gray" />
                        <p className="row-data">
                          <b>{stats?.[card?.sixthField] || "---"} </b>
                          {(stats?.[card?.sixthField] ?? "---") === 1 && card.sixthLine?.includes("users") ? card.sixthLine.replace("users", "user") : card.sixthLine}
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <div className="body-container" style={{ height: "73%", overflowX: window.innerWidth < 1200 && "auto" }}>
        {/*To-do: add all tables */}
        {selTab === "newPolicies" ? (
          <AppGrids.OrderedInsurances period={selPeriod?.newPolicies} setLoading={setLoading} loading={loading} filtered={filtered} />
        ) : selTab === "orderedPolicies" ? (
          <AppGrids.NewInsurances period={selPeriod?.orderedPolicies} setLoading={setLoading} loading={loading} filtered={filtered} />
        ) : selTab === "installments" ? (
          <AppGrids.Installments period={selPeriod?.installments} setLoading={setLoading} loading={loading} filtered={filtered} />
        ) : selTab === "fines" ? (
          <AppGrids.PaidFines period={selPeriod?.fines} setLoading={setLoading} loading={loading} filtered={filtered} />
        ) : selTab === "vignettes" ? (
          <AppGrids.Vignettes period={selPeriod?.vignettes} setLoading={setLoading} loading={loading} filtered={filtered} />
        ) : selTab === "parkingZones" ? (
          <AppGrids.Parking period={selPeriod?.parkingZones} setLoading={setLoading} loading={loading} filtered={filtered} />
        ) : selTab === "claims" ? (
          <AppGrids.Claims period={selPeriod?.claims} setLoading={setLoading} loading={loading} filtered={filtered} />
        ) : selTab === "costs" ? (
          <AppGrids.Costs period={selPeriod?.costs} setLoading={setLoading} loading={loading} filtered={filtered} />
        ) : selTab === "calendar" ? (
          <AppGrids.Events period={selPeriod?.calendar} setLoading={setLoading} loading={loading} filtered={filtered} />
        ) : selTab === "dash" ? (
          <AppGrids.Dash period={selPeriod?.dash} setLoading={setLoading} loading={loading} filtered={filtered} />
        ) : selTab === "averageSpeed" ? (
          null
        ) : selTab === "dashCam" ? (
          dashCamTable === "purchases" ? (
            <AppGrids.DashcamPurchases period={selPeriod?.dashCam} setLoading={setLoading} loading={loading} filtered={filtered} />
          ) : (
            <AppGrids.DashcamPublishedReports period={selPeriod?.dashCam} setLoading={setLoading} loading={loading} filtered={filtered} />
          )
        ) : null}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  stats: state.app.stats,
});
const mapDispatchToProps = (dispatch) => ({
  getStats: (payload) => dispatch(getStats(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(App);
